import React from 'react'
import Slider from 'wix-base-ui/lib/controls/slider'
import RadioButtons from 'wix-base-ui/lib/controls/radioButtons'
import constants from '../../utils/constants'

const AUTO = 'auto'
const CUSTOM = 'custom'
class LineHeight extends React.Component {
    getSelectedOption() {
        return this.props.value === '' ? AUTO : CUSTOM
    }

    getOptions() {
        return [
            {value: AUTO, label: this.props.translate('text_editor_line_spacing_automatic')},
            {value: CUSTOM, label: this.props.translate('text_editor_line_spacing_customize')}
        ]
    }

    handleSelectionChange(val) {
        if (val === AUTO) {
            this.props.execCommand('lineHeight', constants.TRISTATE_OFF)
        } else if (this.props.value === '') {
            this.props.execCommand('lineHeight', '1.2em')
        }
    }

    handleSliderChange(val) {
        this.props.execCommand('lineHeight', val + 'em', {execWithoutFocus: true})
    }

    getLineHeightValue() {
        if (this.props.value === '') {
            return AUTO
        }

        return parseFloat(this.props.value)
    }

    renderSlider() {
        if (this.getSelectedOption() === CUSTOM) {
            return (
                <Slider value={this.getLineHeightValue()}
                        onChange={val => this.handleSliderChange(val)}
                        min={0.5} max={3} step={0.1} onSlideEnd={this.props.onSlideEnd}/>
            )
        }

        return null
    }

    render() {
        return (
            <div className="richtext-slider-container">
                <span className="label">{this.props.translate('lineheight_slider_label')}</span>
                <RadioButtons value={this.getSelectedOption()}
                              className="line-spacing"
                              options={this.getOptions()}
                              onChange={val => this.handleSelectionChange(val)}/>
                {this.renderSlider()}
            </div>
        )
    }
}

LineHeight.propTypes = {
    value: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number
    ]),
    execCommand: React.PropTypes.func,
    onSlideEnd: React.PropTypes.func,
    translate: React.PropTypes.func.isRequired
}

module.exports = LineHeight



// WEBPACK FOOTER //
// ./src/components/toolbar/lineHeight.jsx